export default "__VITE_ASSET__DzUwyd2s__"